import HttpService from "./http.service";

class ReferenceService extends HttpService {
    list = (params) => this.get("reference/list", params);

    create = (data) => this.post(`reference/store`, data);

    editReference = (id, data) => this.patch(`reference/${id}`, data);

    createOrder = (data) => this.post(`orderRequest`, data);

    show = (id) => this.get(`suppliers/job/${id}`);

    update = (id, data) => this.put(`suppliers/job/${id}`, data);


}

export default new ReferenceService();
